module.exports = __webpack_public_path__ + "img/error.82ba1667.svg";